export default __webpack_public_path__ + "static/magdalena-tyszkiewicz-bff39b68ca5798498af1aa28ae5295fd.jpg";